import { TransactionResponseStatus } from './transaction-response-status.enum';

export class TransactionResponseModel {
    sequencial: number;
    situacaoTransferencia: TransactionResponseStatus;
    mensagem: string;
    sucesso: TransactionSuccessModel;
}

export class DataTransferModel {
    codBancoDestino: number;
    nomeBancoDestino: string;
    codAgenciaDestino: number;
    codContaDestino: string;
    valor: number;
    tipoContaFavorecido: number;
    nomeFavorecido: string;
    cPFCNPJFavorecido: string;
    autenticacao: string;
    dataEmissao: string;
}

export class TransactionSuccessModel {
    transacao: DataTransferModel;
    valor: number;
    codigoTransferencia: number;
    tipoTransacao: string;
    dataContabil: string;
    dataTransacao: string;
    tipoMovimentacao: string;
}

export class TransactionReceiptModel {
	autorizado: boolean;
	agendado: boolean;
	nomeFavorecido: string;
	nomeBancoDestino: string;
	codBancoDestino: number;
	codAgenciaDestino: number;
	codContaDestino: string;
	cpfCnpjFavorecido: string;
	valor: number;
	dataContabil: string;
	dataEmissao: string;
	tipoTransacao: string;
	autenticacao: string;
	situacaoTransferencia: TransactionResponseStatus;

	codigoBarras: string;
	valorDocumento: number;
	dataVencimento: string;

	abatimentoTitulo: number;
	desconto: number;
	juros: number;
	multa: number;
	encargos: number;

	usuarioAgencia: string;
	usuarioNumeroConta: string;
	usuarioDocumento: string;
	usuarioNome: string;
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/transfers-other-banks/transfer-response/models/trasanction-response.model.ts